import React from 'react';

import { connect } from 'react-redux';
import CategoryTooltip from './CategoryTooltip';
import { Layout } from 'app/components/base/Layout';
import TripList from 'app/components/search-results/TripList';
import Button from 'app/components/base/Button';
import style from './style.css';
import Icon from 'app/components/base/Icon';
import { showMore } from 'app/actions/search-results';
import CN from 'classnames';
import { constants } from 'mz-sdk';
import { getMainStep } from 'mz-sdk/models/step'
import { FormattedMessage } from 'translations';
import config from 'config';

const messages = {
  moreWithScore: { id: 'SEARCH_RESULTS.VIEW_MORE_WITH_SCORE' },
  more: { id: 'SEARCH_RESULTS.VIEW_MORE' },
};

const CATEGORY_ICON_MAP = {
  'Standard': 'sedan',
  'Premium': 'sedan',
  'First class': 'sedan',
  'Standard Green': 'sedan',
  'Premium Green': 'sedan',
  'Standard 6-seater': 'suv',
  'Minibus': 'bus',
  'Mini Bus': 'bus',
  'Taxi': 'taxi',
  'Minicab': 'taxi',
  'Moto taxi': 'moto',
  'Water taxi': 'ferry',
  'Standard shared': 'van',
  'Taxi shared': 'taxi',
  'Shared water shuttle': 'ferry',
  'Shared water taxi': 'ferry',
  'Bus': 'bus',
  'Train': 'train',
  'Express train': 'train',
  'Public transit': 'train',
};

function getCategoryIconName(filter) {
  // Check existing SDK mapping first
  if (constants.CATEGORIES_FILTERS[filter]) {
    return constants.CATEGORIES_FILTERS[filter];
  }
  // Check new category names
  if (CATEGORY_ICON_MAP[filter]) {
    return CATEGORY_ICON_MAP[filter];
  }
  // Dynamic pattern: "Standard #-seater" or "Premium #-seater" (seats > 6 = van)
  const seaterMatch = filter && filter.match(/^(Standard|Premium)\s+(\d+)-seater$/i);
  if (seaterMatch) {
    const seats = parseInt(seaterMatch[2], 10);
    return seats > 6 ? 'van' : 'suv';
  }
  return 'sedan';
}

class Category extends React.Component {
  state = { showMore: false };

  getIcon(type, filter) {
    return (
      <Icon
        family="mozio"
        name={getCategoryIconName(filter)}
        className={style.icon}
      />
    );
  }

  handleClick = (event) => {
    event.stopPropagation();
    this.props.showMore();
    this.setState({ showMore: true });
  }

  getAllOptions() {
    const {
      trips,
      headTrips,
      tailTrips,
    } = this.props;

    return [
      ...(headTrips || []),
      ...(tailTrips || []),
      ...(trips || [])
    ]
  }

  getRenderedOptions() {
    const { headTrips, tailTrips } = this.props;
    const { showMore } = this.state
    const MIN_VISIBLE = 2;

    if (showMore) {
      return this.getAllOptions()
    }
    if (headTrips?.length >= MIN_VISIBLE) {
      return headTrips
    }
    if (headTrips?.length > 0) {
      const remaining = MIN_VISIBLE - headTrips.length;
      return [...headTrips, ...(tailTrips || []).slice(0, remaining)]
    }
    return this.getAllOptions().slice(0, MIN_VISIBLE)
  }

  getBestTailOptionDetails() {
    const trip = this.props.tailTrips?.[0]
    if (!trip) return null

    const mainStep = getMainStep(trip.steps)
    return {
      price: trip.price.totalWithoutPlatformFee,
      supplierScore: mainStep.provider.supplierScore
    }
  }

  render() {
    const { showMore } = this.state
    const {
      vehicle_type,
      vehicle_type_name: rawVehicleTypeName,
      vehicle_type_description: rawVehicleTypeDescription,
      className,
      type,
      filter,
      mobile,
    } = this.props;

    const vehicleTypeName = rawVehicleTypeName || 'Standard';
    const vehicleTypeDescription = rawVehicleTypeDescription || '';

    const renderedTrips = this.getRenderedOptions()
    const allTrips = this.getAllOptions()
    const bestTailOption = this.getBestTailOptionDetails()
    const viewMoreMessage = bestTailOption?.supplierScore > 0
      ? messages.moreWithScore
      : messages.more

    if (!config.SHOW_VEHICLE_CATEGORY) {
      return (
        <Layout direction="column" className={CN(style.container, className)}>
          <TripList trips={allTrips.map(trip => trip.id)} type={type} mobile={mobile} />
        </Layout>
      );
    }

    return (
      <Layout direction="column" className={CN(style.container, className)}>
        <Layout align="space-between end" className={style.heading}>
          <CategoryTooltip
            categoryName={vehicleTypeName}
            tooltipText={vehicleTypeDescription}
            origin={(
              <Layout align="start center">
                {this.getIcon(type, filter)}
                <h2 className={style.categoryName}>
                  {vehicleTypeName}
                </h2>
                <Icon
                  inline
                  interactive
                  family="stamp"
                  className={style.iconHelp}
                >
                  ?
                </Icon>
              </Layout>
            )}
          />
        </Layout>
        <TripList
          trips={renderedTrips.map(trip => trip.id)}
          type={type}
          vehicleType={vehicle_type}
          mobile={mobile}
        />
        {!showMore && bestTailOption && (allTrips.length - renderedTrips.length > 0) && (
          <Layout align="center center" data-testid="view-more-results">
            <Button clear nocaps className={style.more} onClick={this.handleClick}>
              <FormattedMessage
                {...viewMoreMessage}
                values={{
                  options: allTrips.length - renderedTrips.length,
                  price: bestTailOption.price,
                  score: bestTailOption.supplierScore,
                }}
              />
              <Icon name="keyboard_arrow_down" small />
            </Button>
          </Layout>
        )}
      </Layout>
    );
  }
}

// TODO: move to Flow types
// Category.propTypes = {
//   showMore: PropTypes.func.isRequired,
//   trip_type: PropTypes.string.isRequired,
//   vehicle_type: PropTypes.string,
//   type: PropTypes.string,
//   filter: PropTypes.string,
//   trips: PropTypes.array.isRequired,
//   className: PropTypes.string,
//   mobile: PropTypes.bool
// };

export default connect(null, { showMore })(Category);
